/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */

import { AxiosError } from "axios";
import { FaTag } from "react-icons/fa";
import api from "../../../services/api";
import { styled } from "styled-components";
import React, { useCallback, useEffect, useState } from "react";
import ModalEscolhaFormatoRelatorio from "../../../components/modal-escolha-formato-relatorio";
import { useAppSelector } from "../../../store/hooks";
import ModalForm from "../../../components/modal-form";
import { TipoFormulario } from "../../../services/constantes";
import { RelatorioCard } from "../../../components/relatorio-card";
import { LocaSmartLayout } from "../../../components/locasmart-layout";
import ProgressBarModal from "../../../components/progressbar-relatorio";
import { AgrupamentoRelatorio, Coluna, ConfiguracaoBanda, FormatoRelatorio, Relatorio, Totalizador } from "../../../components/relatorio";
import { useFiliais } from "../../../hooks/useFiliais";
import { obterEhAdmin, obterIdTenent, obterNomeEmpresa, obterNomeUsuario, usuarioTemPermissao } from "../../../services/seguranca";
import { formatarData, formatarParaReais, converterStatusPagamentoParaTexto, converterTipoStatusLancamentoParaTexto, parseDateFromString, dateToInputValue } from "../../../services/utilitarios";
import { calcularTotaisReceitas } from './calcularTotaisReceitas';
import { ApiError, Banco, Campo, Categoria, ContextoRelatorioFluxoCaixa, ContextoRelatorioDespesas, ContextoRelatorioReceitas, Opcao, RelatorioDespesas, RelatorioFluxoCaixa, RelatorioReceitas, TipoExibirRelatorioReceita, TipoFiltroData, TipoModoVisualizacaoRelatorio, TipoOrdenacaoRelatorio, TpRelatorioFinanceiro, StatusPagamento, TipoStatusLancamento, Veiculo } from "../../../services/tipos";
import { toast } from "react-toastify";
import RelatorioComissoes from "./comissoes";

const ContainerRelatorioCard = styled.div`
  gap: 10px;
  width: auto;
  display: grid;
  margin: 20px;
  grid-template-columns: repeat(5, 1fr);
  
  @media (max-width: 768px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 2fr));
  }
`;

const Title = styled.h1`
  font-size: 18px;
  font-weight: 500;
  color: #666;
  margin-top: 20px;
  margin-left: 20px;
`;

function RelatorioFinanceiro() {
    const [veiculo, setVeiculo] = useState('TODOS');
    const [locacao, setLocacao] = useState('TODOS');
    const [carregando, setCarregando] = useState(false);
    const [dataFinal, setDataFinal] = useState<string>();
    const [reportTrigger, setReportTrigger] = useState(0);
    const [dataInicial, setDataInicial] = useState<string>();
    const [totalSaidas, setTotalSaidas] = useState<number>(0);
    const [exibirContexto, setExibirContexto] = useState(false);
    const [locacoesOpcoes, setLocacoes] = useState<Opcao[]>([]);
    const [locatariosOpcoes, setLocatarios] = useState<Opcao[]>([]);
    const [totalDespesas, setTotalDespesas] = useState<number>(0);
    const [totalReceitas, setTotalReceitas] = useState<number>(0);
    const [categorias, setCategorias] = useState<Categoria[]>([]);
    const [totalEntradas, setTotalEntradas] = useState<number>(0);
    const [veiculosOpcoes, setVeiculosOpcoes] = useState<Opcao[]>([]);
    const [veiculos, setVeiculos] = useState<Veiculo[]>([]);
    const [forcarAtualizacao, setForcarAtualizacao] = useState(false);
    const [entidadeASerAtualizada, setEntidadeASerAtualizada] = useState({});
    const [campoVeiculoHabilitado, setCampoVeiculoHabilitado] = useState(false);
    const [campoLocacaoHabilitado, setCampoLocacaoHabilitado] = useState(false);
    const [campoLocatarioHabilitado, setCampoLocatarioHabilitado] = useState(false);
    const [categoriasEscolhidas, setCategoriasEscolhidas] = useState<any[]>([]);
    const [veiculosEscolhidos, setVeiculosEscolhidos] = useState<any[]>([]);
    const [totalReceitasParcelas, setTotalReceitasParcelas] = useState<number>(0);
    const [dadosRelatorioDespesas, setDadosRelatorioDespesas] = useState<any[]>([]);
    const [dadosRelatorioReceitas, setDadosRelatorioReceitas] = useState<any[]>([]);
    const [dadosRelatorioFluxoCaixa, setDadosRelatorioFluxoCaixa] = useState<any[]>([]);
    const [relatorio, setRelatorio] = useState<TpRelatorioFinanceiro>(TpRelatorioFinanceiro.Nenhum);
    const [escolhaExibir, setEscolhaExibir] = useState<TipoExibirRelatorioReceita>(TipoExibirRelatorioReceita.Todos);
    const [modoVisualizacaoRelatorio, setModoVisualizacaoRelatorio] = useState<TipoModoVisualizacaoRelatorio>(TipoModoVisualizacaoRelatorio.Detalhado);
    const [formatoRelatorio, setFormatoRelatorio] = useState<FormatoRelatorio>('pdf');
    const [exibirEscolhaFormato, setExibirEscolhaFormato] = useState(false);
    const entidadeRelatorioPendente = React.useRef<any>(null);
    const [bancosOpcoesRelatorio, setBancosOpcoesRelatorio] = useState<{ label: string; valor: string }[]>([]);
    const [exibirColunaBanco, setExibirColunaBanco] = useState(false);
    const [agruparPorBanco, setAgruparPorBanco] = useState(false);
    const [mostrarAvancadoRelatorio, setMostrarAvancadoRelatorio] = useState(false);
    const [exibirApenasPendenciasReceitas, setExibirApenasPendenciasReceitas] = useState(false);
    const [filiaisEscolhidas, setFiliaisEscolhidas] = useState<any[]>([]);
    // Visao "Exibir valores com comissao calculada": o relatorio passa a trazer SOMENTE as comissoes
    // que cada filial ganhou (backend calcula), agrupadas por filial.
    const [exibirComissaoFilial, setExibirComissaoFilial] = useState(false);
    // Agrupamento do relatorio de Receitas: ordena e agrupa as linhas de detalhe por
    // locatario ou veiculo, com subtotal de cada grupo e total geral no rodape. null = sem agrupar.
    const [agruparReceitasPor, setAgruparReceitasPor] = useState<'locatario' | 'veiculo' | null>(null);
    const [, setPesquisarPorAtual] = useState<number | null>(null);
    const [locatarioFiltro, setLocatarioFiltro] = useState<string>('');
    const [exibirPendenciasColunas, setExibirPendenciasColunas] = useState(false);

    const { empresaTemFiliais, usuarioTemFilialAtribuida, filiaisOptions, labelComFilial, filialSelecionada, getNomeFilial } = useFiliais();
    const token = useAppSelector(state => state.token);
    // Usuário comissionado (não-admin com vínculo de filial): o checkbox de comissão fica
    // INVISÍVEL e sempre marcado — ele só vê o que vai receber (o backend também força).
    const usuarioComissionado = usuarioTemFilialAtribuida && !obterEhAdmin(token);
    const [abrirComissoesSinal, setAbrirComissoesSinal] = useState(0);

    const tratarErro = useCallback((error: AxiosError<ApiError>) => {
        setCarregando(false);
        const errorMessage = error.response?.data?.Mensagem || 'Erro desconhecido';
        toast.error(`Não foi possível continuar a operação Relatório Financeiro: ${errorMessage}`);
    }, []);

    useEffect(() => {
        api.get(`/bancoPorEmpresa/${obterIdTenent(token)}?apenasAtivos=false`)
            .then(r => {
                const opcoes = [
                    { label: '(Sem banco)', valor: '00000000-0000-0000-0000-000000000000' },
                    ...r.data.map((b: Banco) => ({ label: b.apelido, valor: b.id }))
                ];
                setBancosOpcoesRelatorio(opcoes);
            })
            .catch(() => setBancosOpcoesRelatorio([]));
    }, [token]);

    const fetchVeiculos = async () => {
        if (!usuarioTemPermissao(token, 'veiculo_visualizar')) return;
        setCarregando(true);
        try {
            const response = await api.get(`/VeiculoPorEmpresa/${obterIdTenent(token)}`);
            const novasOpcoes = response.data.map((veiculo: any) => ({
                valor: veiculo.id,
                label: labelComFilial(`${veiculo.placa}:  ${veiculo.marca} ${veiculo.modelo} ${veiculo.ano}`, veiculo.idFilial),
            }));
            setVeiculos(response.data);
            setVeiculosOpcoes(novasOpcoes);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    };

    const fetchLocacoes = async () => {
        if (!usuarioTemPermissao(token, 'locacao_visualizar')) return;
        setCarregando(true);
        try {
            const response = await api.get(`/LocacaoPorEmpresaSemPaginacao/${obterIdTenent(token)}`);
            const novasOpcoes = response.data.map((l: any) => ({
                valor: l.id,
                label: labelComFilial(`${l.locatario.documento} ${l.locatario.nome}: ${l.veiculo.placa} ${l.veiculo.marca} ${l.veiculo.modelo} ${l.veiculo.ano}`, l.idFilial),
            }));
            setLocacoes(novasOpcoes);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    };

    const fetchLocatarios = async () => {
        if (!usuarioTemPermissao(token, 'locatario_visualizar')) return;
        try {
            const response = await api.get(`/LocatariosPorEmpresa/${obterIdTenent(token)}`);
            const novasOpcoes = response.data.map((l: any) => ({
                valor: l.id,
                label: labelComFilial(`${l.documento ?? ''} ${l.nome}`.trim(), l.idFilial),
            }));
            setLocatarios(novasOpcoes);
        } catch (error: any) {
            tratarErro(error);
        }
    };

    const fetchCategoriaPorEmpresa = async () => {
        setCarregando(true);
        await api.get(`/CategoriaPorEmpresa/${obterIdTenent(token)}`)
            .then(response => {
                setTimeout(() => {
                    setCategorias(response.data);
                    setCarregando(false);
                }, 250);
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error);
            });
    }

    const colunasRelatorioBase: Coluna[] = (relatorio === TpRelatorioFinanceiro.Receitas) ? [
        { propriedade: "veiculo", titulo: "Veículo" },
        { propriedade: "locatario", titulo: "Locatário" },
        { propriedade: "motivo", titulo: "Motivo/Descrição" },
        { propriedade: "dataPrevisto", titulo: "Data Prevista" },
        { propriedade: "dataRealizado", titulo: "Data Pagamento" },
        { propriedade: "status", titulo: "Status" },
        { propriedade: "valor", titulo: "Vr" },
        { propriedade: "categoria", titulo: "Categoria" }
    ] : (relatorio === TpRelatorioFinanceiro.Despesas) ? [
        { propriedade: "veiculo", titulo: "Veículo" },
        { propriedade: "locatario", titulo: "Locatário" },
        { propriedade: "motivo", titulo: "Motivo/Descrição" },
        { propriedade: "data", titulo: "Data" },
        { propriedade: "status", titulo: "Status" },
        { propriedade: "valor", titulo: "Vr" },
        { propriedade: "categoria", titulo: "Categoria" }
    ] : (relatorio === TpRelatorioFinanceiro.FluxoCaixa) ? [
        { propriedade: "veiculo", titulo: "Veículo" },
        { propriedade: "locatario", titulo: "Locatário" },
        { propriedade: "motivo", titulo: "Motivo/Descrição" },
        { propriedade: "data", titulo: "Data" },
        { propriedade: "status", titulo: "Status" },
        { propriedade: "valor", titulo: "Vr" },
        { propriedade: "categoria", titulo: "Categoria" },
        {
            propriedade: "tipo",
            titulo: "Tipo",
            estiloCondicional: (valor: string, rowData: any) => {
                if (valor === "ENTRADA") {
                    return { fillColor: "#DFF0D8" };
                } else if (valor === "SAÍDA") {
                    return { fillColor: "#F2DEDE" };
                }
                return null;
            },
        },
    ] : [];

    const colunasComBanco: Coluna[] = exibirColunaBanco
        ? [...colunasRelatorioBase, { propriedade: "bancoFormatado", titulo: "Banco" }]
        : colunasRelatorioBase;

    const colunasRelatorio: Coluna[] = exibirComissaoFilial
        ? [...colunasComBanco, { propriedade: "filialNome", titulo: "Unidade" }]
        : colunasComBanco;

    const categoriasTexto = categoriasEscolhidas.length > 0
        ? categoriasEscolhidas.map(c => c.nome).join(', ')
        : 'TODOS';

    let fonteDeDados = [];
    let tituloRelatorio = '';
    let subTituloRelatorio = '';
    let rodapeRelatorio: string[] = [];

    switch (relatorio) {
        case TpRelatorioFinanceiro.Despesas:
            fonteDeDados = dadosRelatorioDespesas;
            tituloRelatorio = 'Despesas';
            rodapeRelatorio = [`Total em Despesas: ${formatarParaReais(totalDespesas)}`];
            break;

        case TpRelatorioFinanceiro.Receitas: {
            fonteDeDados = dadosRelatorioReceitas;
            tituloRelatorio = 'Receitas';
            rodapeRelatorio = [
                `Total em Receitas: ${formatarParaReais(totalReceitas)}`,
                `Quantidade total de parcelas: ${totalReceitasParcelas}`
            ];
            // Quando o usuario pediu pendencias, o total geral detalha A Vencer / Pago / Em Atraso.
            if (exibirPendenciasColunas) {
                const totaisGerais = calcularTotaisReceitas(dadosRelatorioReceitas);
                rodapeRelatorio.push(
                    `A Vencer: ${formatarParaReais(totaisGerais.aVencer)}`,
                    `Pago: ${formatarParaReais(totaisGerais.pago)}`,
                    `Em Atraso: ${formatarParaReais(totaisGerais.emAtraso)}`,
                );
            }
            break;
        }

        case TpRelatorioFinanceiro.FluxoCaixa:
            fonteDeDados = dadosRelatorioFluxoCaixa;
            tituloRelatorio = 'Fluxo de caixa';
            rodapeRelatorio = [
                `Total em Entradas: ${formatarParaReais(totalEntradas)}`,
                `Total em Saídas: ${formatarParaReais(totalSaidas)}`,
                `Saldo: ${formatarParaReais(totalEntradas - totalSaidas)}`
            ];
            break;
    }

    if (exibirComissaoFilial && (relatorio === TpRelatorioFinanceiro.Receitas || relatorio === TpRelatorioFinanceiro.FluxoCaixa)) {
        tituloRelatorio = 'Comissões por unidade';
        const totalComissoes = relatorio === TpRelatorioFinanceiro.FluxoCaixa ? totalEntradas : totalReceitas;
        rodapeRelatorio = [`Total de comissões: ${formatarParaReais(totalComissoes)}`];
    }

    // Relatorio de Receitas agrupado (Locatario/Veiculo) usa o mecanismo generico de
    // agrupamento do gerador (ordena, detalha as linhas, subtotal por grupo) com as
    // colunas normais; nao ha colapso de linhas.
    const colunasRelatorioExibidas: Coluna[] = colunasRelatorio;

    const filialRelatorioTexto = empresaTemFiliais
        ? ` | Unidade: ${filiaisEscolhidas.length > 0
            ? filiaisEscolhidas.map((f: any) => f.nome).join(', ')
            : (filialSelecionada ? getNomeFilial(filialSelecionada) : 'Todas as unidades')}`
        : '';

    if (relatorio === TpRelatorioFinanceiro.Receitas) {
        // Ao filtrar por locatario, "Locação: TODOS | Veículo: TODOS" e ruido: mostra o locatario.
        const filtroPrincipal = locatarioFiltro
            ? `Locatário: ${locatarioFiltro}`
            : `Locação: ${locacao || 'TODOS'} | Veículo: ${veiculo || 'TODOS'}`;
        subTituloRelatorio = `${filtroPrincipal} | Período de Emissão ${dataInicial} à ${dataFinal} | Categoria: ${categoriasTexto}${filialRelatorioTexto}`;
    } else if (relatorio === TpRelatorioFinanceiro.Despesas || relatorio === TpRelatorioFinanceiro.FluxoCaixa) {
        subTituloRelatorio = `Locação: ${locacao || 'TODOS'} | Veículo: ${veiculo || 'TODOS'} | Período de Emissão ${dataInicial} à ${dataFinal} | Categoria: ${categoriasTexto}${filialRelatorioTexto}`;
    }

    const obterMesAnteriorAHoje = (): Date => {
        const hoje = new Date();
        hoje.setMonth(hoje.getMonth() - 1);
        return hoje;
    };

    const dataMesAnterior: Date = obterMesAnteriorAHoje();

    const GUID_SEM_BANCO = '00000000-0000-0000-0000-000000000000';

    const onSave = (e: any) => {
        if ((e['dataInicial'] && e['dataFinal']) && (e['dataInicial'] > e['dataFinal'])) {
            toast.info('A data final deve ser maior (posterior) a data inicial.')
            return;
        }
        // Guarda os dados do formulário e abre o modal de escolha de formato.
        // A geração real (handleBuscar...) só roda após o usuário confirmar PDF ou XLSX.
        entidadeRelatorioPendente.current = e;
        setExibirEscolhaFormato(true);
    };

    const dispararGeracaoRelatorio = (formato: FormatoRelatorio) => {
        setFormatoRelatorio(formato);
        setExibirEscolhaFormato(false);
        // NAO fechamos o modal de filtros (setExibirContexto): o PDF/XLSX abre em outra aba e o
        // usuario mantem os filtros preenchidos para gerar de novo sem digitar tudo outra vez.
        // Para fechar, basta o X/Cancelar do proprio modal.

        const e = entidadeRelatorioPendente.current;
        if (!e) return;
        entidadeRelatorioPendente.current = null;

        const idBancoBruto = e['idBanco'] || undefined;
        const filtrarApenasSemBanco = idBancoBruto === GUID_SEM_BANCO;
        const idBancoEfetivo = filtrarApenasSemBanco ? undefined : idBancoBruto;

        const agrupar = Boolean(e['agruparPorBanco']);
        setAgruparPorBanco(agrupar);
        // Agrupamento do relatorio de Receitas por locatario ou veiculo (vazio = nao agrupa).
        const agruparPor = e['agruparReceitasPor'];
        setAgruparReceitasPor(agruparPor === 'locatario' || agruparPor === 'veiculo' ? agruparPor : null);
        // Detalhamento de pendencias (A Vencer / Pago / Em Atraso) nos subtotais e no total geral.
        setExibirPendenciasColunas(Boolean(e['checkTrazerPagamentosPendentes']) || Boolean(e['checkTrazerLancamentosPendentes']));
        // Para agrupar por banco precisamos dos dados bancarios no backend (mesmo
        // LEFT JOIN usado por "Exibir informacoes bancarias"). Ja a coluna de banco
        // por linha so aparece se o usuario marcar explicitamente essa opcao.
        const exibirInfoBancariasUsuario = Boolean(e['exibirInformacoesBancarias']);
        setExibirColunaBanco(exibirInfoBancariasUsuario);
        const exibirInfoBancariasBackend = exibirInfoBancariasUsuario || agrupar;

        // Comissionado: comporta-se como se o checkbox (invisível para ele) estivesse marcado.
        // Restrito a Receitas/FluxoCaixa: a visão de comissão não existe em Despesas, e ativá-la
        // lá acrescenta coluna "Filial" vazia e força o agrupamento por filial.
        const relatorioComComissao = relatorio === TpRelatorioFinanceiro.Receitas || relatorio === TpRelatorioFinanceiro.FluxoCaixa;
        const exibirComissao = relatorioComComissao && (usuarioComissionado || Boolean(e['exibirComissaoFilial']));
        setExibirComissaoFilial(exibirComissao);

        if (relatorio === TpRelatorioFinanceiro.Despesas) {
            let contexto = {
                dataInicial: e['dataInicial'],
                dataFinal: e['dataFinal'],
                veiculos: veiculosEscolhidos.map(vei => ({
                    Id: vei.id,
                })),
                idLocacao: (e['idLocacao']?.trim() === '' || e['idLocacao'] === null || e['idLocacao'] === '0') ? null : e['idLocacao'],
                idLocatario: (e['idLocatario']?.trim() === '' || e['idLocatario'] === null || e['idLocatario'] === '0') ? null : e['idLocatario'],
                idEmpresa: obterIdTenent(token),
                trazerSaidasPendentes: Boolean(e['checkTrazerLancamentosPendentes']),
                naoIncluirManutencoes: Boolean(e['checkNaoIncluirManutencoes']),
                ordenacao: e['ordenacao'] || TipoOrdenacaoRelatorio.MaisRecenteParaMaisAntigo,
                categorias: categoriasEscolhidas.map(cat => ({
                    Id: cat.id,
                })),
                exibirApenasPendentes: Boolean(e['checkTrazerApenasLancamentosPendentes']),
                filtrarPorData: e['filtrarPorData'] || TipoFiltroData.DataVencimento,
                idBanco: idBancoEfetivo,
                filtrarApenasSemBanco: filtrarApenasSemBanco,
                exibirInformacoesBancarias: exibirInfoBancariasBackend,
                ...(filiaisEscolhidas.length > 0 && { idFiliais: filiaisEscolhidas.map((f: any) => f.id) }),
            };

            handleBuscarRelatorioDespesas(contexto);
        } else if (relatorio === TpRelatorioFinanceiro.Receitas) {
            let contexto = {
                dataFinal: e['dataFinal'],
                veiculos: veiculosEscolhidos.map(vei => ({
                    Id: vei.id,
                })),
                idLocacao: (e['idLocacao']?.trim() === '' || e['idLocacao'] === null || e['idLocacao'] === '0') ? null : e['idLocacao'],
                idLocatario: (e['idLocatario']?.trim() === '' || e['idLocatario'] === null || e['idLocatario'] === '0') ? null : e['idLocatario'],
                dataInicial: e['dataInicial'],
                idEmpresa: obterIdTenent(token),
                trazerSaidasPendentes: Boolean(e['checkTrazerLancamentosPendentes']),
                trazerPagamentosPendentes: Boolean(e['checkTrazerPagamentosPendentes']),
                exibirApenasPendentes: Boolean(e['checkExibirApenasPendencias']),
                exibir: e['exibir'] || TipoExibirRelatorioReceita.Todos,
                ordenacao: e['ordenacao'] || TipoOrdenacaoRelatorio.MaisRecenteParaMaisAntigo,
                categorias: categoriasEscolhidas.map(cat => ({
                    Id: cat.id,
                })),
                filtrarPorData: e['filtrarPorData'] || TipoFiltroData.DataVencimento,
                idBanco: idBancoEfetivo,
                filtrarApenasSemBanco: filtrarApenasSemBanco,
                exibirInformacoesBancarias: exibirInfoBancariasBackend,
                exibirComissaoFilial: exibirComissao,
                ...(filiaisEscolhidas.length > 0 && { idFiliais: filiaisEscolhidas.map((f: any) => f.id) }),
            };

            handleBuscarRelatorioReceitas(contexto);
        } else if (relatorio === TpRelatorioFinanceiro.FluxoCaixa) {
            let contexto = {
                dataFinal: e['dataFinal'],
                veiculos: veiculosEscolhidos.map(vei => ({
                    Id: vei.id,
                })),
                idLocacao: (e['idLocacao']?.trim() === '' || e['idLocacao'] === null || e['idLocacao'] === '0') ? null : e['idLocacao'],
                idLocatario: (e['idLocatario']?.trim() === '' || e['idLocatario'] === null || e['idLocatario'] === '0') ? null : e['idLocatario'],
                dataInicial: e['dataInicial'],
                idEmpresa: obterIdTenent(token),
                exibir: e['exibir'] || TipoExibirRelatorioReceita.Todos,
                ordenacao: e['ordenacao'] || TipoOrdenacaoRelatorio.MaisRecenteParaMaisAntigo,
                separarEntradasSaidas: e['separarEntradasSaidas'] || false,
                trazerLancamentosPendentes: Boolean(e['trazerLancamentosPendentes']),
                trazerPagamentosPendentes: Boolean(e['trazerPagamentosPendentes']),
                filtrarPorData: e['filtrarPorData'] || TipoFiltroData.DataVencimento,
                idBanco: idBancoEfetivo,
                filtrarApenasSemBanco: filtrarApenasSemBanco,
                exibirInformacoesBancarias: exibirInfoBancariasBackend,
                exibirComissaoFilial: exibirComissao,
                ...(filiaisEscolhidas.length > 0 && { idFiliais: filiaisEscolhidas.map((f: any) => f.id) }),
            };

            handleBuscarRelatorioFluxoCaixa(contexto);
        }
    };

    const contexto: Campo[] = relatorio === TpRelatorioFinanceiro.Despesas ? [
        { coluna: 1, label: 'Data Inicial', largura: 3, nome: 'dataInicial', tipo: 'date', linha: 1, required: true, visible: true },
        { coluna: 2, label: 'Data Final', largura: 3, nome: 'dataFinal', tipo: 'date', linha: 1, required: true, visible: true },
        {
            coluna: 3, label: 'Filtrar por data de', largura: 6, nome: 'filtrarPorData', tipo: 'select', linha: 2, required: false, visible: true,
            opcoes: [
                { label: 'Vencimento', valor: TipoFiltroData.DataVencimento },
                { label: 'Pagamento', valor: TipoFiltroData.DataPagamento },
            ],
        },
        {
            coluna: 4, label: 'Pesquisar por', largura: 6, nome: 'pesquisarPor', tipo: 'select', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, opcoes: [{ label: 'Veículo', valor: 1 }, { label: 'Locação', valor: 2 }, { label: 'Locatário', valor: 3 }], onCampoDigitar(e) {
                setPesquisarPorAtual(e !== null && e !== undefined && e !== '' ? Number(e) : null);
                const fetchOnCampoDigitarPesquisar = async () => {
                    if (e == 1) {
                        setCampoLocacaoHabilitado(false);
                        setCampoLocatarioHabilitado(false);
                        setCampoVeiculoHabilitado(true);
                        setEntidadeASerAtualizada({ idLocacao: '0', idVeiculo: '0', idLocatario: '0' });
                        setLocacao('TODOS');
                        setVeiculo('TODOS');
                        setForcarAtualizacao(true);
                        await fetchVeiculos();
                    } else if (e == 2) {
                        setCampoVeiculoHabilitado(false);
                        setCampoLocatarioHabilitado(false);
                        setCampoLocacaoHabilitado(true);
                        setEntidadeASerAtualizada({ idLocacao: '0', idVeiculo: '0', idLocatario: '0' });
                        setVeiculo('TODOS');
                        setLocacao('TODOS');
                        setForcarAtualizacao(true);
                        await fetchLocacoes();
                    } else if (e == 3) {
                        setCampoVeiculoHabilitado(false);
                        setCampoLocacaoHabilitado(false);
                        setCampoLocatarioHabilitado(true);
                        setEntidadeASerAtualizada({ idLocacao: '0', idVeiculo: '0', idLocatario: '0' });
                        setVeiculo('TODOS');
                        setLocacao('TODOS');
                        setForcarAtualizacao(true);
                        await fetchLocatarios();
                    }
                }

                fetchOnCampoDigitarPesquisar();
            },
        },
        {
            coluna: 1, label: "Atenção", largura: 12, nome: "atencao", tipo: "label", linha: 1, subLabel: "Para exibir o relatório de todos os veículos basta não selecionar um em específico", required: false, visible: () => {
                return campoVeiculoHabilitado;
            }
        },
        {
            coluna: 1, label: 'Veículo', largura: 6, nome: 'veiculos', tipo: 'multiselect', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, apenasLeitura: !campoVeiculoHabilitado,
            selectMultiProps: {
                dataSource: veiculos,
                onSelectionChange: ((data: any) => {
                    setVeiculosEscolhidos(data);
                }),
                optionLabelField: 'placa;modelo',
                height: '250px',
                modo: TipoFormulario.tpCadastro,
                initialSelected: [],
                criticarRepeticao: true,
                orderByField: "placa",
                multiValueBackground: "#000000",
            },
        },
        { coluna: 2, label: 'Locação', largura: 6, nome: 'idLocacao', tipo: 'select', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, opcoes: locacoesOpcoes, apenasLeitura: !campoLocacaoHabilitado },
        { coluna: 1, label: 'Locatário', largura: 6, nome: 'idLocatario', tipo: 'select', selectBoxIsCleareable: true, linha: 3, required: false, visible: true, opcoes: locatariosOpcoes, apenasLeitura: !campoLocatarioHabilitado },
        {
            coluna: 1, label: 'Ordenação', largura: 6, nome: 'ordenacao', tipo: 'select', selectBoxIsCleareable: true, linha: 4, required: false, visible: true,
            opcoes: [
                { label: "Mais recente para o mais antigo", valor: TipoOrdenacaoRelatorio.MaisRecenteParaMaisAntigo },
                { label: "Mais antigo para o mais recente", valor: TipoOrdenacaoRelatorio.MaisAntigoParaMaisRecente },
            ], apenasLeitura: false
        },
        {
            coluna: 2, label: 'Modo de Visualização', largura: 6, nome: 'modoVisualizacao', tipo: 'select', selectBoxIsCleareable: true, linha: 4, required: false, visible: true,
            opcoes: [
                { label: "Compacto", valor: TipoModoVisualizacaoRelatorio.Compacto },
                { label: "Detalhado", valor: TipoModoVisualizacaoRelatorio.Detalhado },
            ], apenasLeitura: false, onCampoSair(e: TipoModoVisualizacaoRelatorio) {
                setModoVisualizacaoRelatorio(e)
            },
        },
        {
            coluna: 1, label: 'Categorias', largura: 12, nome: 'categorias', tipo: 'multiselect', linha: 6, required: false, visible: true,
            selectMultiProps: {
                dataSource: categorias,
                onSelectionChange: ((data: any) => {
                    setCategoriasEscolhidas(data);
                }),
                optionLabelField: 'nome;descricao',
                height: '250px',
                modo: TipoFormulario.tpCadastro,
                initialSelected: [],
                criticarRepeticao: true,
                orderByField: "nome",
                optionBackgroundField: "cor"
            },
            opcoes: [
                { label: "Compacto", valor: TipoModoVisualizacaoRelatorio.Compacto },
                { label: "Detalhado", valor: TipoModoVisualizacaoRelatorio.Detalhado },
            ], apenasLeitura: false, onCampoSair(e: TipoModoVisualizacaoRelatorio) {
                setModoVisualizacaoRelatorio(e)
            },
        },
        {
            coluna: 1, label: 'Exibir despesas pendentes', largura: 6, nome: 'checkTrazerLancamentosPendentes', tipo: 'checkbox', linha: 7, required: false, visible: true, ajudinha: {
                texto: "Quando esse campo está marcado, o relatório incluirá também os lançamentos com status 'Pendente'."
            }
        },
        {
            coluna: 2, label: 'Não exibir as manutenções', largura: 6, nome: 'checkNaoIncluirManutencoes', tipo: 'checkbox', linha: 7, required: false, visible: true, ajudinha: {
                texto: "Quando esse campo está marcado, o relatório não trará manutenções, apenas lançamentos financeiros do tipo 'saída'."
            }
        },
        {
            coluna: 1, label: 'Exibir somente o que está pendente', largura: 6, nome: 'checkTrazerApenasLancamentosPendentes', tipo: 'checkbox', linha: 8, required: false, visible: true, ajudinha: {
                texto: "Quando esse campo está marcado, o relatório trará apenas as Depesas pendentes."
            }
        },
        {
            label: '', nome: '_toggleAvancadoDespesas', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: 8, visible: true,
            component: () => (
                <button
                    type="button"
                    onClick={() => setMostrarAvancadoRelatorio(!mostrarAvancadoRelatorio)}
                    style={{ background: 'none', border: 'none', color: '#1F467E', cursor: 'pointer', fontSize: '1rem', padding: 0, textDecoration: 'underline' }}
                >
                    {mostrarAvancadoRelatorio ? 'Ocultar opções avançadas' : 'Mostrar filtros avançados'}
                </button>
            ),
        },
        {
            coluna: 1, label: 'Banco', largura: 6, nome: 'idBanco', tipo: 'select', linha: 9, required: false,
            visible: () => mostrarAvancadoRelatorio,
            selectBoxIsCleareable: true, opcoes: bancosOpcoesRelatorio,
            ajudinha: { texto: 'Filtra registros cujo banco corresponda exatamente ao selecionado. Use "(Sem banco)" para achar pendências.', autoCloseTime: 3 }
        },
        {
            coluna: 2, label: 'Agrupar por banco', largura: 6, nome: 'agruparPorBanco', tipo: 'checkbox', linha: 9, required: false,
            visible: () => mostrarAvancadoRelatorio,
            ajudinha: { texto: 'Agrupa os lançamentos por banco, com subtotal de cada um. Itens sem banco aparecem em "Sem banco".', autoCloseTime: 4 }
        },
        {
            coluna: 2, label: 'Exibir informações bancárias', largura: 6, nome: 'exibirInformacoesBancarias', tipo: 'checkbox', linha: 10, required: false,
            visible: () => mostrarAvancadoRelatorio,
            ajudinha: { texto: 'Inclui uma coluna com dados do banco no relatório.', autoCloseTime: 3 }
        },
        {
            coluna: 1, label: 'Unidade', largura: 6, nome: 'filiais', tipo: 'multiselect', selectBoxIsCleareable: true, linha: 11, required: false,
            visible: () => mostrarAvancadoRelatorio && empresaTemFiliais,
            selectMultiProps: {
                dataSource: filiaisOptions.map(f => ({ id: f.valor, nome: f.label })),
                onSelectionChange: ((data: any) => {
                    setFiliaisEscolhidas(data);
                }),
                optionLabelField: 'nome',
                height: '200px',
                modo: TipoFormulario.tpCadastro,
                initialSelected: [],
                criticarRepeticao: true,
                orderByField: "nome",
                multiValueBackground: "#1F467E",
            },
        },
    ] : relatorio === TpRelatorioFinanceiro.Receitas ? [
        { coluna: 1, label: 'De', largura: 3, nome: 'dataInicial', tipo: 'date', linha: 1, required: true, visible: true },
        { coluna: 2, label: 'Até', largura: 3, nome: 'dataFinal', tipo: 'date', linha: 1, required: true, visible: true },
        {
            coluna: 3, label: 'Filtrar por data de', largura: 6, nome: 'filtrarPorData', tipo: 'select', linha: 2, required: false, visible: true,
            opcoes: [
                { label: 'Vencimento', valor: TipoFiltroData.DataVencimento },
                { label: 'Pagamento', valor: TipoFiltroData.DataPagamento },
            ],
        },
        {
            coluna: 4, label: 'Pesquisar por', largura: 6, nome: 'pesquisarPor', tipo: 'select', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, opcoes: [{ label: 'Veículo', valor: 1 }, { label: 'Locação', valor: 2 }, { label: 'Locatário', valor: 3 }], onCampoDigitar(e) {
                setPesquisarPorAtual(e !== null && e !== undefined && e !== '' ? Number(e) : null);
                const fetchOnCampoDigitarPesquisar = async () => {
                    if (e == 1) {
                        setCampoLocacaoHabilitado(false);
                        setCampoLocatarioHabilitado(false);
                        setCampoVeiculoHabilitado(true);
                        setEntidadeASerAtualizada({ idLocacao: '0', idVeiculo: '0', idLocatario: '0' });
                        setLocacao('TODOS');
                        setVeiculo('TODOS');
                        setForcarAtualizacao(true);
                        await fetchVeiculos();
                    } else if (e == 2) {
                        setCampoVeiculoHabilitado(false);
                        setCampoLocatarioHabilitado(false);
                        setCampoLocacaoHabilitado(true);
                        setEntidadeASerAtualizada({ idLocacao: '0', idVeiculo: '0', idLocatario: '0' });
                        setVeiculo('TODOS');
                        setLocacao('TODOS');
                        setForcarAtualizacao(true);
                        await fetchLocacoes();
                    } else if (e == 3) {
                        setCampoVeiculoHabilitado(false);
                        setCampoLocacaoHabilitado(false);
                        setCampoLocatarioHabilitado(true);
                        setEntidadeASerAtualizada({ idLocacao: '0', idVeiculo: '0', idLocatario: '0' });
                        setVeiculo('TODOS');
                        setLocacao('TODOS');
                        setForcarAtualizacao(true);
                        await fetchLocatarios();
                    }
                }

                fetchOnCampoDigitarPesquisar();
            },
        },
        {
            coluna: 1, label: "Atenção", largura: 12, nome: "atencao", tipo: "label", linha: 1, subLabel: "Para exibir o relatório de todos os veículos basta não selecionar um em específico", required: false, visible: () => {
                return campoVeiculoHabilitado;
            }
        },
        {
            coluna: 1, label: 'Veículo', largura: 6, nome: 'idVeiculo', tipo: 'multiselect', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, selectMultiProps: {
                dataSource: veiculos,
                onSelectionChange: ((data: any) => {
                    setVeiculosEscolhidos(data);
                }),
                optionLabelField: 'placa;modelo',
                height: '250px',
                modo: TipoFormulario.tpCadastro,
                initialSelected: [],
                criticarRepeticao: true,
                orderByField: "placa",
                multiValueBackground: "#000000",
            }, apenasLeitura: !campoVeiculoHabilitado
        },
        { coluna: 2, label: 'Locação', largura: 6, nome: 'idLocacao', tipo: 'select', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, opcoes: locacoesOpcoes, apenasLeitura: !campoLocacaoHabilitado },
        { coluna: 1, label: 'Locatário', largura: 6, nome: 'idLocatario', tipo: 'select', selectBoxIsCleareable: true, linha: 3, required: false, visible: true, opcoes: locatariosOpcoes, apenasLeitura: !campoLocatarioHabilitado },
        {
            coluna: 1, label: 'Exibir', largura: 4, nome: 'exibir', tipo: 'select', selectBoxIsCleareable: true, linha: 5, required: false, visible: true,
            opcoes: [
                { label: "Apenas Pagamentos", valor: TipoExibirRelatorioReceita.ApenasRecebimentos },
                { label: "Apenas Lançamentos", valor: TipoExibirRelatorioReceita.ApenasLançamentos },
                { label: "Todos", valor: TipoExibirRelatorioReceita.Todos },
            ], apenasLeitura: false, onCampoDigitar(e) {
                setEscolhaExibir(e);
            },
        },
        {
            coluna: 2, label: 'Ordenação', largura: 4, nome: 'ordenacao', tipo: 'select', selectBoxIsCleareable: true, linha: 5, required: false, visible: true,
            opcoes: [
                { label: "Mais recente para o mais antigo", valor: TipoOrdenacaoRelatorio.MaisRecenteParaMaisAntigo },
                { label: "Mais antigo para o mais recente", valor: TipoOrdenacaoRelatorio.MaisAntigoParaMaisRecente },
            ], apenasLeitura: false
        },
        {
            coluna: 3, label: 'Modo de Visualização', largura: 4, nome: 'modoVisualizacao', tipo: 'select', selectBoxIsCleareable: true, linha: 5, required: false, visible: true,
            opcoes: [
                { label: "Compacto", valor: TipoModoVisualizacaoRelatorio.Compacto },
                { label: "Detalhado", valor: TipoModoVisualizacaoRelatorio.Detalhado },
            ], apenasLeitura: false, onCampoSair(e: TipoModoVisualizacaoRelatorio) {
                setModoVisualizacaoRelatorio(e)
            },
        },
        {
            coluna: 1, label: 'Categorias', largura: 12, nome: 'categorias', tipo: 'multiselect', linha: 6, required: false, visible: true,
            selectMultiProps: {
                dataSource: categorias,
                onSelectionChange: ((data: any) => {
                    setCategoriasEscolhidas(data);
                }),
                optionLabelField: 'nome;descricao',
                height: '250px',
                modo: TipoFormulario.tpCadastro,
                initialSelected: [],
                criticarRepeticao: true,
                orderByField: "nome",
                optionBackgroundField: "cor"
            },
            opcoes: [
                { label: "Compacto", valor: TipoModoVisualizacaoRelatorio.Compacto },
                { label: "Detalhado", valor: TipoModoVisualizacaoRelatorio.Detalhado },
            ], apenasLeitura: false, onCampoSair(e: TipoModoVisualizacaoRelatorio) {
                setModoVisualizacaoRelatorio(e)
            },
        },
        {
            coluna: 1, label: 'Trazer lançamentos pendentes', largura: 6, nome: 'checkTrazerLancamentosPendentes', tipo: 'checkbox', linha: 7, required: false, visible: true, ajudinha: {
                texto: "Quando esse campo está marcado, o relatório incluirá também os lançamentos com status 'Pendente'."
            }, apenasLeitura: exibirApenasPendenciasReceitas || !(escolhaExibir === TipoExibirRelatorioReceita.Todos || escolhaExibir === TipoExibirRelatorioReceita.ApenasLançamentos)
        },
        {
            coluna: 2, label: 'Trazer pagamentos pendentes', largura: 6, nome: 'checkTrazerPagamentosPendentes', tipo: 'checkbox', linha: 7, required: false, visible: true, ajudinha: {
                texto: "Quando esse campo está marcado, o relatório incluirá também os pagamentos com status 'Pendente'."
            }, apenasLeitura: exibirApenasPendenciasReceitas || !(escolhaExibir === TipoExibirRelatorioReceita.Todos || escolhaExibir === TipoExibirRelatorioReceita.ApenasRecebimentos)
        },
        {
            coluna: 1, label: 'Exibir apenas pendências', largura: 12, nome: 'checkExibirApenasPendencias', tipo: 'checkbox', linha: 7, required: false, visible: true,
            ajudinha: { texto: "Mostra apenas o que já está vencido e ainda não foi pago/resolvido (não traz parcelas a vencer). Os resultados ficam agrupados por locação." },
            onCampoDigitar(e: any) { setExibirApenasPendenciasReceitas(Boolean(e)); }
        },
        {
            label: '', nome: '_toggleAvancadoReceitas', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: 8, visible: true,
            component: () => (
                <button
                    type="button"
                    onClick={() => setMostrarAvancadoRelatorio(!mostrarAvancadoRelatorio)}
                    style={{ background: 'none', border: 'none', color: '#1F467E', cursor: 'pointer', fontSize: '1rem', padding: 0, textDecoration: 'underline' }}
                >
                    {mostrarAvancadoRelatorio ? 'Ocultar opções avançadas' : 'Mostrar filtros avançados'}
                </button>
            ),
        },
        {
            coluna: 1, label: 'Banco', largura: 6, nome: 'idBanco', tipo: 'select', linha: 9, required: false,
            visible: () => mostrarAvancadoRelatorio,
            selectBoxIsCleareable: true, opcoes: bancosOpcoesRelatorio,
            ajudinha: { texto: 'Filtra registros cujo banco corresponda exatamente ao selecionado. Use "(Sem banco)" para achar pendências.', autoCloseTime: 3 }
        },
        {
            coluna: 2, label: 'Agrupar por banco', largura: 6, nome: 'agruparPorBanco', tipo: 'checkbox', linha: 9, required: false,
            visible: () => mostrarAvancadoRelatorio,
            ajudinha: { texto: 'Agrupa os lançamentos por banco, com subtotal de cada um. Itens sem banco aparecem em "Sem banco".', autoCloseTime: 4 }
        },
        {
            coluna: 2, label: 'Exibir informações bancárias', largura: 6, nome: 'exibirInformacoesBancarias', tipo: 'checkbox', linha: 10, required: false,
            visible: () => mostrarAvancadoRelatorio,
            ajudinha: { texto: 'Inclui uma coluna com dados do banco no relatório.', autoCloseTime: 3 }
        },
        {
            coluna: 1, label: 'Unidade', largura: 6, nome: 'filiais', tipo: 'multiselect', selectBoxIsCleareable: true, linha: 11, required: false,
            visible: () => mostrarAvancadoRelatorio && empresaTemFiliais,
            selectMultiProps: {
                dataSource: filiaisOptions.map(f => ({ id: f.valor, nome: f.label })),
                onSelectionChange: ((data: any) => {
                    setFiliaisEscolhidas(data);
                }),
                optionLabelField: 'nome',
                height: '200px',
                modo: TipoFormulario.tpCadastro,
                initialSelected: [],
                criticarRepeticao: true,
                orderByField: "nome",
                multiValueBackground: "#1F467E",
            },
        },
        {
            coluna: 1, label: 'Agrupar Por', largura: 6, nome: 'agruparReceitasPor', tipo: 'select', linha: 12, required: false,
            visible: () => mostrarAvancadoRelatorio,
            selectBoxIsCleareable: true,
            opcoes: [
                { label: 'Locatário', valor: 'locatario' },
                { label: 'Veículo', valor: 'veiculo' },
            ],
            ajudinha: { texto: 'Ordena e agrupa as receitas por locatário ou veículo, com subtotal de cada grupo e total geral no fim.', autoCloseTime: 4 }
        },
        {
            coluna: 1, label: 'Exibir valores com comissão calculada', largura: 12, nome: 'exibirComissaoFilial', tipo: 'checkbox', linha: 13, required: false,
            visible: () => mostrarAvancadoRelatorio && empresaTemFiliais && !usuarioComissionado,
            ajudinha: { texto: 'Traz SOMENTE as comissões que cada unidade ganhou no período (recebimentos pagos de locações com comissão configurada), agrupadas por unidade.', autoCloseTime: 5 }
        },
    ] : relatorio === TpRelatorioFinanceiro.FluxoCaixa ? [
        { coluna: 1, label: 'Data Inicial', largura: 3, nome: 'dataInicial', tipo: 'date', linha: 1, required: true, visible: true },
        { coluna: 2, label: 'Data Final', largura: 3, nome: 'dataFinal', tipo: 'date', linha: 1, required: true, visible: true },
        {
            coluna: 3, label: 'Filtrar por data de', largura: 6, nome: 'filtrarPorData', tipo: 'select', linha: 2, required: false, visible: true,
            opcoes: [
                { label: 'Vencimento', valor: TipoFiltroData.DataVencimento },
                { label: 'Pagamento', valor: TipoFiltroData.DataPagamento },
            ],
        },
        {
            coluna: 4, label: 'Pesquisar por', largura: 6, nome: 'pesquisarPor', tipo: 'select', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, opcoes: [{ label: 'Veículo', valor: 1 }, { label: 'Locação', valor: 2 }, { label: 'Locatário', valor: 3 }], onCampoDigitar(e) {
                setPesquisarPorAtual(e !== null && e !== undefined && e !== '' ? Number(e) : null);
                const fetchOnCampoDigitarPesquisar = async () => {
                    if (e == 1) {
                        setCampoLocacaoHabilitado(false);
                        setCampoLocatarioHabilitado(false);
                        setCampoVeiculoHabilitado(true);
                        setEntidadeASerAtualizada({ idLocacao: '0', idVeiculo: '0', idLocatario: '0' });
                        setLocacao('TODOS');
                        setVeiculo('TODOS');
                        setForcarAtualizacao(true);
                        await fetchVeiculos();
                    } else if (e == 2) {
                        setCampoVeiculoHabilitado(false);
                        setCampoLocatarioHabilitado(false);
                        setCampoLocacaoHabilitado(true);
                        setEntidadeASerAtualizada({ idLocacao: '0', idVeiculo: '0', idLocatario: '0' });
                        setVeiculo('TODOS');
                        setLocacao('TODOS');
                        setForcarAtualizacao(true);
                        await fetchLocacoes();
                    } else if (e == 3) {
                        setCampoVeiculoHabilitado(false);
                        setCampoLocacaoHabilitado(false);
                        setCampoLocatarioHabilitado(true);
                        setEntidadeASerAtualizada({ idLocacao: '0', idVeiculo: '0', idLocatario: '0' });
                        setVeiculo('TODOS');
                        setLocacao('TODOS');
                        setForcarAtualizacao(true);
                        await fetchLocatarios();
                    }
                }

                fetchOnCampoDigitarPesquisar();
            },
        },
        {
            coluna: 1, label: "Atenção", largura: 12, nome: "atencao", tipo: "label", linha: 1, subLabel: "Para exibir o relatório de todos os veículos basta não selecionar um em específico", required: false, visible: () => {
                return campoVeiculoHabilitado;
            }
        },
        {
            coluna: 1, label: 'Veículo', largura: 6, nome: 'idVeiculo', tipo: 'multiselect', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, selectMultiProps: {
                dataSource: veiculos,
                onSelectionChange: ((data: any) => {
                    setVeiculosEscolhidos(data);
                }),
                optionLabelField: 'placa;modelo',
                height: '250px',
                modo: TipoFormulario.tpCadastro,
                initialSelected: [],
                criticarRepeticao: true,
                orderByField: "placa",
                multiValueBackground: "#000000",
            }, apenasLeitura: !campoVeiculoHabilitado
        },
        { coluna: 2, label: 'Locação', largura: 6, nome: 'idLocacao', tipo: 'select', selectBoxIsCleareable: true, linha: 2, required: false, visible: true, opcoes: locacoesOpcoes, apenasLeitura: !campoLocacaoHabilitado },
        { coluna: 1, label: 'Locatário', largura: 6, nome: 'idLocatario', tipo: 'select', selectBoxIsCleareable: true, linha: 3, required: false, visible: true, opcoes: locatariosOpcoes, apenasLeitura: !campoLocatarioHabilitado },
        {
            coluna: 1, label: 'Ordenação', largura: 6, nome: 'ordenacao', tipo: 'select', selectBoxIsCleareable: true, linha: 5, required: false, visible: true,
            opcoes: [
                { label: "Mais recente para o mais antigo", valor: TipoOrdenacaoRelatorio.MaisRecenteParaMaisAntigo },
                { label: "Mais antigo para o mais recente", valor: TipoOrdenacaoRelatorio.MaisAntigoParaMaisRecente },
            ], apenasLeitura: false
        },
        {
            coluna: 2, label: 'Modo de Visualização', largura: 6, nome: 'modoVisualizacao', tipo: 'select', selectBoxIsCleareable: true, linha: 5, required: false, visible: true,
            opcoes: [
                { label: "Compacto", valor: TipoModoVisualizacaoRelatorio.Compacto },
                { label: "Detalhado", valor: TipoModoVisualizacaoRelatorio.Detalhado },
            ], apenasLeitura: false, onCampoSair(e: TipoModoVisualizacaoRelatorio) {
                setModoVisualizacaoRelatorio(e)
            },
        },
        {
            coluna: 1, label: 'Separar Entradas e Saídas', largura: 12, nome: 'separarEntradasSaidas', tipo: 'checkbox', linha: 7, required: false, visible: true,
        },
        {
            coluna: 1, label: 'Trazer lançamentos pendentes', largura: 12, nome: 'trazerLancamentosPendentes', tipo: 'checkbox', linha: 8, required: false, visible: true,
            apenasLeitura: !(escolhaExibir === TipoExibirRelatorioReceita.Todos || escolhaExibir === TipoExibirRelatorioReceita.ApenasLançamentos)
        },
        {
            coluna: 1, label: 'Trazer pagamentos pendentes', largura: 12, nome: 'trazerPagamentosPendentes', tipo: 'checkbox', linha: 9, required: false, visible: true,
            apenasLeitura: !(escolhaExibir === TipoExibirRelatorioReceita.Todos || escolhaExibir === TipoExibirRelatorioReceita.ApenasRecebimentos)
        },
        {
            label: '', nome: '_toggleAvancadoFluxo', tipo: 'custom', required: false,
            largura: 12, coluna: 1, linha: 10, visible: true,
            component: () => (
                <button
                    type="button"
                    onClick={() => setMostrarAvancadoRelatorio(!mostrarAvancadoRelatorio)}
                    style={{ background: 'none', border: 'none', color: '#1F467E', cursor: 'pointer', fontSize: '1rem', padding: 0, textDecoration: 'underline' }}
                >
                    {mostrarAvancadoRelatorio ? 'Ocultar opções avançadas' : 'Mostrar opções avançadas'}
                </button>
            ),
        },
        {
            coluna: 1, label: 'Banco', largura: 6, nome: 'idBanco', tipo: 'select', linha: 11, required: false,
            visible: () => mostrarAvancadoRelatorio,
            selectBoxIsCleareable: true, opcoes: bancosOpcoesRelatorio,
            ajudinha: { texto: 'Filtra registros cujo banco corresponda exatamente ao selecionado. Use "(Sem banco)" para achar pendências.', autoCloseTime: 3 }
        },
        {
            coluna: 2, label: 'Agrupar por banco', largura: 6, nome: 'agruparPorBanco', tipo: 'checkbox', linha: 11, required: false,
            visible: () => mostrarAvancadoRelatorio,
            ajudinha: { texto: 'Agrupa os lançamentos por banco, com subtotal de cada um. Itens sem banco aparecem em "Sem banco".', autoCloseTime: 4 }
        },
        {
            coluna: 2, label: 'Exibir informações bancárias', largura: 6, nome: 'exibirInformacoesBancarias', tipo: 'checkbox', linha: 12, required: false,
            visible: () => mostrarAvancadoRelatorio,
            ajudinha: { texto: 'Inclui uma coluna com dados do banco no relatório.', autoCloseTime: 3 }
        },
        {
            coluna: 1, label: 'Unidade', largura: 6, nome: 'filiais', tipo: 'multiselect', selectBoxIsCleareable: true, linha: 13, required: false,
            visible: () => mostrarAvancadoRelatorio && empresaTemFiliais,
            selectMultiProps: {
                dataSource: filiaisOptions.map(f => ({ id: f.valor, nome: f.label })),
                onSelectionChange: ((data: any) => {
                    setFiliaisEscolhidas(data);
                }),
                optionLabelField: 'nome',
                height: '200px',
                modo: TipoFormulario.tpCadastro,
                initialSelected: [],
                criticarRepeticao: true,
                orderByField: "nome",
                multiValueBackground: "#1F467E",
            },
        },
        {
            coluna: 1, label: 'Exibir valores com comissão calculada', largura: 12, nome: 'exibirComissaoFilial', tipo: 'checkbox', linha: 14, required: false,
            visible: () => mostrarAvancadoRelatorio && empresaTemFiliais && !usuarioComissionado,
            ajudinha: { texto: 'Traz SOMENTE as comissões que cada unidade ganhou no período (recebimentos pagos de locações com comissão configurada), agrupadas por unidade.', autoCloseTime: 5 }
        },
    ] : [];

    const buscarRelatorioDespesas = async (contexto: ContextoRelatorioDespesas) => {
        setCarregando(true);
        try {
            const response = await api.post('/Relatorio/Despesas', contexto);
            const dadosFormatados: RelatorioDespesas[] = response.data.map((d: any) => ({
                valor: `${formatarParaReais(d.valor)}`,
                valorNumerico: Number(d.valor),
                motivo: `${d.motivo && d.motivo.toUpperCase()}` || '',
                data: formatarData(new Date(d.data)),
                locatario: d.locatario.documento && d.locatario.nome ? `${d.locatario.documento} - ${d.locatario.nome}` : '',
                veiculo: d.veiculo.placa ? `${d.veiculo.placa} - ${d.veiculo.marca} - ${d.veiculo.modelo} - ${d.veiculo.ano}` : '',
                status: converterTipoStatusLancamentoParaTexto(d.status).toUpperCase(),
                categoria: d.categoria?.nome || 'MANUTENÇÃO',
                bancoFormatado: d.bancoFormatado || '',
            }));

            const totalEmDespesas = response.data.reduce((acc: any, d: any) => acc + Number(d.valor), 0);
            setTotalDespesas(totalEmDespesas);
            setDadosRelatorioDespesas(dadosFormatados);
            setReportTrigger(prev => prev + 1);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    };

    const buscarRelatorioReceitas = async (contexto: ContextoRelatorioReceitas) => {
        setCarregando(true);
        try {
            const response = await api.post('/Relatorio/Receitas', contexto);
            // Hoje em YYYY-MM-DD (data local) para classificar pendencias sem deslocamento de fuso.
            const agora = new Date();
            const hojeYmd = `${agora.getFullYear()}-${String(agora.getMonth() + 1).padStart(2, '0')}-${String(agora.getDate()).padStart(2, '0')}`;
            const dadosFormatados: any[] = response.data.map((d: any) => {
            const previstoYmd = (d.dataPrevisto || '').slice(0, 10);
            const pago = d.ehPagamento
                ? d.status === StatusPagamento.Pago
                : d.status === TipoStatusLancamento.Resolvido;
            const pendente = !pago;
            const emAtrasoFlag = pendente && previstoYmd !== '' && previstoYmd < hojeYmd;
            const aVencerFlag = pendente && previstoYmd !== '' && previstoYmd >= hojeYmd;
            return ({
                valor: `${formatarParaReais(d.valor)}`,
                valorNumerico: Number(d.valor),
                motivo: `${d.motivo && d.motivo.toUpperCase()}` || '',
                dataPrevisto: formatarData(new Date(d.dataPrevisto)) == '01/01/1901' ? '' : formatarData(new Date(d.dataPrevisto)),
                dataRealizado: formatarData(new Date(d.dataRealizado)) == '01/01/1901' ? '' : formatarData(new Date(d.dataRealizado)),
                locatario: d.locatario?.documento && d.locatario?.nome ? `${d.locatario?.documento} - ${d.locatario.nome}` : '',
                veiculo: d.veiculo?.placa ? `${d.veiculo?.placa} - ${d.veiculo?.marca} - ${d.veiculo?.modelo} - ${d.veiculo?.ano}` : '',
                status: d.ehPagamento ? converterStatusPagamentoParaTexto(d.status).toUpperCase() : converterTipoStatusLancamentoParaTexto(d.status).toUpperCase(),
                categoria: d.categoria?.nome || 'PAGAMENTO',
                bancoFormatado: d.bancoFormatado || '',
                filialNome: d.filialNome || 'Sem unidade',
                // Campos brutos usados como chave de agrupamento (placa / nome do locatario).
                // null quando ausente -> cai no grupo "Sem veiculo" / "Sem locatario".
                placa: d.veiculo?.placa ?? null,
                idLocacao: d.idLocacao ?? null,
                locatarioNome: d.locatario?.nome ?? null,
                periodoInicio: d.periodoInicio ?? null,
                periodoFim: d.periodoFim ?? null,
                recorrencia: d.periodicidadePagamento ?? null,
                locacaoStatus: d.locacaoStatus ?? null,
                emAtrasoFlag,
                aVencerFlag,
                pagoFlag: pago,
            });
            });

            const totalEmReceitas = response.data.reduce((acc: any, d: any) => acc + Number(d.valor), 0);
            setTotalReceitas(totalEmReceitas);
            setTotalReceitasParcelas(response.data.length);
            setDadosRelatorioReceitas(dadosFormatados);
            setReportTrigger(prev => prev + 1);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    };

    const buscarRelatorioFluxoCaixa: (contexto: ContextoRelatorioFluxoCaixa) => Promise<void> = async (contexto) => {
        setCarregando(true);
        try {
            const response = await api.post('/Relatorio/FluxoCaixa', contexto);
            const dadosFormatados: RelatorioFluxoCaixa[] = response.data.map((d: any) => ({
                valor: `${formatarParaReais(d.valor)}`,
                valorNumerico: Number(d.valor),
                motivo: `${d.motivo && d.motivo.toUpperCase()}` || '',
                data: formatarData(new Date(d.dataPrevisto)) === '01/01/1901' ? '' : formatarData(new Date(d.data)),
                locatario: d.locatario.documento && d.locatario.nome ? `${d.locatario.documento} - ${d.locatario.nome}` : '',
                veiculo: d.veiculo.placa ? `${d.veiculo.placa} - ${d.veiculo.marca} - ${d.veiculo.modelo} - ${d.veiculo.ano}` : '',
                status: d.ehPagamento
                    ? (new Date(d.data) < new Date()) && (d.status as StatusPagamento != StatusPagamento.Pago)
                        ? "EM ATRASO"
                        : converterStatusPagamentoParaTexto(d.status).toUpperCase()
                    : (new Date(d.data) < new Date()) && (d.status as TipoStatusLancamento != TipoStatusLancamento.Resolvido)
                        ? "VENCIDO"
                        : converterTipoStatusLancamentoParaTexto(d.status).toUpperCase(),
                categoria: d.categoria?.nome || 'PAGAMENTO',
                tipo: d.tipo,
                bancoFormatado: d.bancoFormatado || '',
                filialNome: d.filialNome || 'Sem unidade',
            }));

            const totalEmEntradas = response.data
                .filter((d: any) => d.tipo === 'ENTRADA')
                .reduce((acc: number, d: any) => acc + Number(d.valor), 0);

            const totalEmSaidas = response.data
                .filter((d: any) => d.tipo !== 'ENTRADA')
                .reduce((acc: number, d: any) => acc + Number(d.valor), 0);

            setTotalEntradas(totalEmEntradas);
            setTotalSaidas(totalEmSaidas);
            setDadosRelatorioFluxoCaixa(dadosFormatados);
            setReportTrigger(prev => prev + 1);
        } catch (error: any) {
            tratarErro(error);
        } finally {
            setCarregando(false);
        }
    };

    const handleBuscarRelatorioDespesas = async (e: any) => {
        // "yyyy-MM-dd" vira meia-noite UTC com new Date e saía um dia antes no cabeçalho do relatório
        const novaDataInicial = formatarData(parseDateFromString(String(e['dataInicial']).slice(0, 10)));
        const novaDataFinal = formatarData(parseDateFromString(String(e['dataFinal']).slice(0, 10)));
        const veiculoLabel = veiculosOpcoes.find(v => v.valor == e['idVeiculo'])?.label;
        const locacaoLabel = locacoesOpcoes.find(l => l.valor == e['idLocacao'])?.label;
        const novoVeiculo = veiculoLabel ? veiculoLabel.replace(':', ' -') : 'TODOS';
        setDataInicial(novaDataInicial);
        setDataFinal(novaDataFinal);
        setVeiculo(novoVeiculo);
        setLocacao(locacaoLabel || 'TODOS');
        await buscarRelatorioDespesas(e);
    };

    const handleBuscarRelatorioReceitas = async (e: any) => {
        // "yyyy-MM-dd" vira meia-noite UTC com new Date e saía um dia antes no cabeçalho do relatório
        const novaDataInicial = formatarData(parseDateFromString(String(e['dataInicial']).slice(0, 10)));
        const novaDataFinal = formatarData(parseDateFromString(String(e['dataFinal']).slice(0, 10)));
        const veiculoLabel = veiculosOpcoes.find(v => v.valor == e['idVeiculo'])?.label;
        const locacaoLabel = locacoesOpcoes.find(l => l.valor == e['idLocacao'])?.label;
        const locatarioLabel = locatariosOpcoes.find(l => l.valor == e['idLocatario'])?.label;
        const novoVeiculo = veiculoLabel ? veiculoLabel.replace(':', ' -') : 'TODOS';
        setDataInicial(novaDataInicial);
        setDataFinal(novaDataFinal);
        setVeiculo(novoVeiculo);
        setLocacao(locacaoLabel || 'TODOS');
        setLocatarioFiltro(locatarioLabel || '');
        await buscarRelatorioReceitas(e);
    };

    const handleBuscarRelatorioFluxoCaixa = async (e: any) => {
        // "yyyy-MM-dd" vira meia-noite UTC com new Date e saía um dia antes no cabeçalho do relatório
        const novaDataInicial = formatarData(parseDateFromString(String(e['dataInicial']).slice(0, 10)));
        const novaDataFinal = formatarData(parseDateFromString(String(e['dataFinal']).slice(0, 10)));
        const veiculoLabel = veiculosOpcoes.find(v => v.valor == e['idVeiculo'])?.label;
        const locacaoLabel = locacoesOpcoes.find(l => l.valor == e['idLocacao'])?.label;
        const novoVeiculo = veiculoLabel ? veiculoLabel.replace(':', ' -') : 'TODOS';
        setDataInicial(novaDataInicial);
        setDataFinal(novaDataFinal);
        setVeiculo(novoVeiculo);
        setLocacao(locacaoLabel || 'TODOS');
        await buscarRelatorioFluxoCaixa(e);
    };

    const onOpenContexto = async () => {
        // Reset all form-related states
        setCampoLocacaoHabilitado(false);
        setCampoVeiculoHabilitado(false);
        setCampoLocatarioHabilitado(false);
        setEscolhaExibir(TipoExibirRelatorioReceita.Todos);
        setCategoriasEscolhidas([]);
        setVeiculo('TODOS');
        setLocacao('TODOS');
        setVeiculosOpcoes([]);
        setLocacoes([]);
        setExibirApenasPendenciasReceitas(false);
        setAgruparPorBanco(false);
        setExibirColunaBanco(false);
        setLocatarioFiltro('');
        setExibirPendenciasColunas(false);
        setExibirComissaoFilial(false);

        // Initialize form fields with null values for idVeiculo and idLocacao
        setEntidadeASerAtualizada({
            // Dia LOCAL: a montagem anterior usava UTC e, depois das 21h, o "hoje" virava amanhã.
            dataInicial: `${dateToInputValue(dataMesAnterior)}T00:00:00Z`,
            dataFinal: `${dateToInputValue(new Date())}T00:00:00Z`,
            exibir: TipoExibirRelatorioReceita.Todos,
            modoVisualizacao: TipoModoVisualizacaoRelatorio.Detalhado,
            idVeiculo: null,
            idLocacao: null,
            checkTrazerLancamentosPendentes: false,
            checkTrazerPagamentosPendentes: false,
            checkExibirApenasPendencias: false,
            checkNaoIncluirManutencoes: false,
            separarEntradasSaidas: false,
            pesquisarPor: null,
            filtrarPorData: TipoFiltroData.DataVencimento,
            agruparPorBanco: false,
            exibirInformacoesBancarias: false,
            agruparReceitasPor: null,
            exibirComissaoFilial: false,
        });
        setPesquisarPorAtual(null);
        setForcarAtualizacao(true);

        // Fetch necessary data
        await fetchCategoriaPorEmpresa();
    };

    const handleAplicarFiltro = (tpRelatorio: TpRelatorioFinanceiro) => {
        // Reset all relevant states when switching reports
        setRelatorio(tpRelatorio);
        setDadosRelatorioDespesas([]);
        setDadosRelatorioReceitas([]);
        setDadosRelatorioFluxoCaixa([]);
        setTotalDespesas(0);
        setTotalReceitas(0);
        setTotalReceitasParcelas(0);
        setTotalEntradas(0);
        setTotalSaidas(0);
        setDataInicial(undefined);
        setDataFinal(undefined);
        setVeiculo('TODOS');
        setLocacao('TODOS');
        setLocatarioFiltro('');
        setExibirPendenciasColunas(false);
        setExibirComissaoFilial(false);
        setCategoriasEscolhidas([]);
        setEscolhaExibir(TipoExibirRelatorioReceita.Todos);
        setModoVisualizacaoRelatorio(TipoModoVisualizacaoRelatorio.Detalhado);
        setVeiculosOpcoes([]);
        setLocacoes([]);
        setExibirContexto(true);
    };

    useEffect(() => {
        if (forcarAtualizacao) {
            setForcarAtualizacao(false);
        }
    }, [forcarAtualizacao]);

    const configuracaoBanda: ConfiguracaoBanda = {
        mestre: {
            colunas: colunasRelatorioExibidas
        },
    };

    const totalizadoresAgrupamento: Totalizador[] = relatorio === TpRelatorioFinanceiro.FluxoCaixa
        ? [
            { coluna: 'valor', label: 'Entradas', calculo: (d: any[]) => formatarParaReais(d.filter(x => x.tipo === 'ENTRADA').reduce((acc, x) => acc + (x.valorNumerico || 0), 0)) },
            { coluna: 'valor', label: 'Saídas', calculo: (d: any[]) => formatarParaReais(d.filter(x => x.tipo !== 'ENTRADA').reduce((acc, x) => acc + (x.valorNumerico || 0), 0)) },
            { coluna: 'valor', label: 'Saldo', calculo: (d: any[]) => formatarParaReais(d.reduce((acc, x) => x.tipo === 'ENTRADA' ? acc + (x.valorNumerico || 0) : acc - (x.valorNumerico || 0), 0)) },
        ]
        : relatorio === TpRelatorioFinanceiro.Receitas
        ? [
            // Subtotal de cada grupo; com pendencia ligada, detalha A Vencer / Pago / Em Atraso.
            { coluna: 'valor', label: 'Subtotal', calculo: (d: any[]) => formatarParaReais(calcularTotaisReceitas(d).total) },
            ...(exibirPendenciasColunas ? [
                { coluna: 'valor', label: 'A Vencer', calculo: (d: any[]) => formatarParaReais(calcularTotaisReceitas(d).aVencer) },
                { coluna: 'valor', label: 'Pago', calculo: (d: any[]) => formatarParaReais(calcularTotaisReceitas(d).pago) },
                { coluna: 'valor', label: 'Em Atraso', calculo: (d: any[]) => formatarParaReais(calcularTotaisReceitas(d).emAtraso) },
            ] : []),
        ]
        : [
            { coluna: 'valor', label: 'Subtotal', calculo: (d: any[]) => formatarParaReais(d.reduce((acc, x) => acc + (x.valorNumerico || 0), 0)) },
        ];

    // Agrupamento do relatorio. "Agrupar Por" (locatario/veiculo) das Receitas tem precedencia
    // sobre "Agrupar por banco" — o gerador suporta apenas um nivel de agrupamento.
    const agrupamentoReceitas: AgrupamentoRelatorio | undefined =
        (relatorio === TpRelatorioFinanceiro.Receitas && agruparReceitasPor)
            ? {
                campoTitulo: agruparReceitasPor === 'locatario' ? 'locatarioNome' : 'placa',
                tituloVazio: agruparReceitasPor === 'locatario' ? 'Sem locatário' : 'Sem veículo',
                totalizadores: totalizadoresAgrupamento,
            }
            : undefined;

    // Na visao de comissoes, agrupa por filial (subtotal por filial + total geral no rodape).
    const agrupamentoComissao: AgrupamentoRelatorio | undefined = exibirComissaoFilial
        ? {
            campoTitulo: 'filialNome',
            tituloVazio: 'Sem unidade',
            totalizadores: [{ coluna: 'valor', label: 'Subtotal', calculo: (d: any[]) => formatarParaReais(d.reduce((acc, x) => acc + (x.valorNumerico || 0), 0)) }],
        }
        : undefined;

    const agrupamentoRelatorio: AgrupamentoRelatorio | undefined = agrupamentoComissao
        ?? agrupamentoReceitas
        ?? (agruparPorBanco
            ? { campoTitulo: 'bancoFormatado', tituloVazio: 'Sem banco', totalizadores: totalizadoresAgrupamento }
            : undefined);

    return (
        <LocaSmartLayout>
            <Title>
                Financeiro:
            </Title>

            <ContainerRelatorioCard>
                <RelatorioCard
                    titulo="Despesas"
                    subtitulo="Relatório completo das despesas/saídas da sua locadora."
                    onAplicarFiltros={() => handleAplicarFiltro(TpRelatorioFinanceiro.Despesas)}
                    corBotao="#E43F52"
                />

                <RelatorioCard
                    titulo="Receitas"
                    subtitulo="Relatório completo das receitas/entradas da sua locadora."
                    onAplicarFiltros={() => handleAplicarFiltro(TpRelatorioFinanceiro.Receitas)}
                    corBotao="#28a745"
                />

                <RelatorioCard
                    titulo="Fluxo de Caixa"
                    subtitulo="Relatório completo do fluxo de caixa da sua locadora."
                    onAplicarFiltros={() => handleAplicarFiltro(TpRelatorioFinanceiro.FluxoCaixa)}
                    corBotao="#2ECC71"
                />

                <RelatorioCard
                    titulo="Comissões"
                    subtitulo="Relatório de comissões dos usuários."
                    onAplicarFiltros={() => { setRelatorio(TpRelatorioFinanceiro.Comissoes); setAbrirComissoesSinal(s => s + 1); }}
                    corBotao="#1F467E"
                />
            </ContainerRelatorioCard>

            {relatorio === TpRelatorioFinanceiro.Comissoes ? (
                <RelatorioComissoes embutido abrirSinal={abrirComissoesSinal} />
            ) : (
              <>
            <Relatorio
                trigger={reportTrigger}
                configuracaoBanda={configuracaoBanda}
                fonteDeDados={fonteDeDados}
                titulo={tituloRelatorio}
                subtitulo={subTituloRelatorio}
                usuario={obterNomeUsuario(token)}
                rodape={rodapeRelatorio}
                empresa={obterNomeEmpresa(token)}
                modoCompacto={modoVisualizacaoRelatorio == TipoModoVisualizacaoRelatorio.Compacto}
                formato={formatoRelatorio}
                agrupamento={agrupamentoRelatorio}
            />

            <ModalForm
                urlTutorial={relatorio == TpRelatorioFinanceiro.Despesas ? 'https://youtu.be/WbT_h0wLNtI' : ''}
                campos={contexto}
                onShow={onOpenContexto}
                carregando={false}
                modo={TipoFormulario.tpCadastro}
                titulo={"Gerar Relatório: " + tituloRelatorio}
                tituloBotaoOk="Gerar"
                apiConfig={{
                    endpoint: '',
                    idTenentCampo: 'idEmpresa',
                    requisicaoBemSucedida: () => { toast.success('Relatório gerado com sucesso') },
                    tratarErro: () => { },
                }}
                onSave={onSave}
                onCancel={() => setExibirContexto(false)}
                onHide={() => setExibirContexto(false)}
                show={exibirContexto}
                tamanho="lg"
                atualizacaoEntidade={{
                    entidadeUsadaParaAtualizacao: entidadeASerAtualizada,
                    forcarAtualizacao: forcarAtualizacao
                }}
            />

            <ProgressBarModal
                carregando={carregando}
                titulo="Carregando relatório..."
            />

            <ModalEscolhaFormatoRelatorio
                open={exibirEscolhaFormato}
                onClose={() => setExibirEscolhaFormato(false)}
                onConfirmar={dispararGeracaoRelatorio}
            />
              </>
            )}
        </LocaSmartLayout>
    );
}

export default RelatorioFinanceiro;